const columnConfigurations = [
    {
        minWidth: 1450,
        columns: ["Id", "Conversion Type", "Source", "Conversion Date", "Customer", "Loan Officer", "Old Loan Number", "New Loan Number", "Old Funded Date", "New Funded Date"]
    },
    {
        maxWidth: 1449,
        minWidth: 1100,
        columns: ["Conversion Type", "Conversion Date", "Customer", "Loan Officer", "New Loan Number", "Old Funded Date", "New Funded Date"]
    },
    {
        maxWidth: 1099,
        minWidth: 800,
        columns: ["Conversion Type", "Conversion Date", "Customer", "Loan Officer", "New Loan Number", "Old Funded Date"]
    }
]

export const getColumnsConfig = (w: number): Set<string> => {
    for (const config of columnConfigurations) {
        if ((!config.minWidth || w >= config.minWidth) && (!config.maxWidth || w < config.maxWidth)) {
            return new Set(config.columns);
        }
    }
}